module.exports = __webpack_public_path__ + "img/3-(1).6309b8d6.jpg";